// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestTags-cls1_q1t","cls2":"ResearchInterestTags-cls2_S1w ResearchInterestTags-cls1_q1t","hasError":"ResearchInterestTags-hasError_fpy"};